import { render, staticRenderFns } from "./CardsAdvancementBack.vue?vue&type=template&id=72395ec0"
import script from "./CardsAdvancementBack.vue?vue&type=script&lang=js"
export * from "./CardsAdvancementBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports